import { QueryClient } from 'react-query';

import { REACT_QUERY_CLIENT_CONFIG } from './constants';

// A single shared QueryClient for the whole build. Both the /app entry point
// and the AppShell (used standalone in the lui overview build) import this same
// instance so they share one cache instead of each creating their own — which
// previously caused the same endpoints (profile/, status/) to be fetched twice.
export const queryClient = new QueryClient(REACT_QUERY_CLIENT_CONFIG);
